import { render, staticRenderFns } from "./PAPrintCertificate.vue?vue&type=template&id=265780dd&"
import script from "./PAPrintCertificate.vue?vue&type=script&lang=js&"
export * from "./PAPrintCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PAPrintCertificate.vue"
export default component.exports